import { Component, input, viewChild } from '@angular/core';
import {
  ButtonComponent,
  ModalActionsDirective,
  ModalComponent,
  ModalTitleDirective,
} from '@totalenergiescode/tds-angular';

@Component({
  selector: 'app-psf-confirmation-modal-2',
  imports: [
    ModalTitleDirective,
    ModalComponent,
    ModalActionsDirective,
    ButtonComponent,
  ],
  templateUrl: './psf-confirmation-modal.component.html'
})
export class PsfConfirmationModalComponent {
  title = input<string>();
  text = input<string>();
  closeText = input<string>();
  confirmText = input<string>();

  private readonly modal = viewChild.required(ModalComponent);

  close(action?: string) {
    this.modal().closeModal(action);
  }
}
